import variables from '@/styles/variables.scss'

const settings = {
  state: {
    theme: variables.theme,
    success: '#67c23a'
  },

  mutations: {
    CHANGE_SETTING(state, { key, value }) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        state[key] = value
      }
    }
  },

  actions: {
    changeTheme({ commit }, color) {
      commit('CHANGE_SETTING', { key: 'theme', value: color })

      document.documentElement.style.setProperty('--color-primary', color)

      localStorage.setItem('--color-primary', color)
    }
  }
}

export default settings
